import { ModuleWithProviders, NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { ColorsService } from "./colors/colors.service";
import { RouterModule } from "@angular/router";
import { PaginationModule } from "ngx-bootstrap/pagination";
import { TypeaheadModule } from "ngx-bootstrap/typeahead";
import { SortService } from "./tables/sort.service";
import { SortableColumnComponent } from "./tables/sortable-column.component";
import { SortableTableDirective } from "./tables/sortable-table.directive";
import { NgxIntlTelInputModule } from "ngx-intl-tel-input";
import { BsDatepickerConfig, BsDatepickerModule, DatepickerModule } from "ngx-bootstrap/datepicker";
import { TimepickerModule } from "ngx-bootstrap/timepicker";
import { TabsModule } from "ngx-bootstrap/tabs";
import { CarouselModule } from "ngx-bootstrap/carousel";
import { PageHeaderComponent } from "./components/page-header/page-header.component";
import { CheckallDirective } from "./directives/checkall/checkall.directive";
import { ViewTransactionComponent } from "./components/view-transaction/view-transaction.component";

export function getDatepickerConfig(): BsDatepickerConfig {
  return Object.assign(new BsDatepickerConfig(), {
    useUtc: true
  });
}

@NgModule({
  imports: [
    RouterModule,
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    // AccordionModule.forRoot(),
    // AlertModule.forRoot(),
    // ButtonsModule.forRoot(),
    // CarouselModule.forRoot(),
    // CollapseModule.forRoot(),
    DatepickerModule.forRoot(),
    BsDatepickerModule.forRoot(),
    TimepickerModule.forRoot(),
    // BsDropdownModule.forRoot(),
    // ModalModule.forRoot(),
    PaginationModule.forRoot(),
    // ProgressbarModule.forRoot(),
    // RatingModule.forRoot(),
    TabsModule.forRoot(),
    // TimepickerModule.forRoot(),
    // TooltipModule.forRoot(),
    // PopoverModule.forRoot(),
    TypeaheadModule.forRoot(),
    NgxIntlTelInputModule,
    CarouselModule.forRoot(),
  ],
  providers: [ColorsService, SortService, { provide: BsDatepickerConfig, useFactory: getDatepickerConfig }],
  declarations: [
    SortableColumnComponent,
    SortableTableDirective,
    PageHeaderComponent,
    CheckallDirective,
    ViewTransactionComponent,
  ],
  exports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    RouterModule,
    // AccordionModule,
    // AlertModule,
    // ButtonsModule,
    // CarouselModule,
    // CollapseModule,
    DatepickerModule,
    BsDatepickerModule,
    TimepickerModule,
    // BsDropdownModule,
    // ModalModule,
    PaginationModule,
    // ProgressbarModule,
    TabsModule,
    // TimepickerModule,
    // TooltipModule,
    // PopoverModule,
    TypeaheadModule,
    // SparklineDirective,
    // ScrollableDirective,
    SortableColumnComponent,
    SortableTableDirective,
    NgxIntlTelInputModule,
    CarouselModule,
    PageHeaderComponent,
    CheckallDirective,
    // FlotDirective
    ViewTransactionComponent,
  ],
})
export class SharedModule {
  static forRoot(): ModuleWithProviders<SharedModule> {
    return {
      ngModule: SharedModule,
    };
  }
}
